export default __webpack_public_path__ + "static/media/yahoo.31202b42.png";